import Typography from '@serko/zui/es/Typography';
import React, { FunctionComponent } from 'react';
import pure from 'recompose/pure';
import { ColumnSecondaryText } from '../TextStyles/ColumnSecondaryText';
import { ProviderNameText } from '../TextStyles/ProviderNameText';

interface OwnProps {
  /**
   * @example
   * "Virgin Airways"
   */
  providerName: string;

  /**
   * @example
   * "VA815*, NZ875"
   */
  flightNumbers: string;

  /**
   * @example
   * "*NZ1850 operated by Qantas Airways"
   */
  codeshare?: string;
}

interface AirProps extends OwnProps {}

const AirProviderDetailsBase: FunctionComponent<AirProps> = ({
  providerName,
  flightNumbers,
  codeshare,
}) => {
  return (
    <>
      <ProviderNameText>{providerName}</ProviderNameText>
      <ColumnSecondaryText>{flightNumbers}</ColumnSecondaryText>
      {!!codeshare && (
        <Typography variant="caption" color="textSecondary" lineClamp>
          {codeshare}
        </Typography>
      )}
    </>
  );
};

/**
 * Air provider details
 *
 * @example
 * "Virgin Airways"
 * "VA815*, NZ875"
 * "*NZ1850 operated by Qantas Airways"
 */
export const AirProviderDetails = pure(AirProviderDetailsBase);

AirProviderDetails.displayName = 'AirProviderDetails';
